<template>
  <Dialog :visible="visible" header="Editar Cantidad" :modal="true" :style="{ width: '320px' }" class="p-fluid" :closable="false">
    <div class="flex flex-column align-items-center">
      <div class="text-4xl font-bold mb-3 p-3 bg-gray-100 border-round w-full text-center border-1 surface-border">
        {{ cantidadTemporal }}
      </div>
      <div class="grid w-full m-0 p-0">
        <div class="col-4 p-1" v-for="n in [1,2,3,4,5,6,7,8,9]" :key="n">
          <Button :label="String(n)" class="w-full p-button-outlined p-button-secondary font-bold text-xl py-3" @click="numpadAgregar(n)" />
        </div>
        <div class="col-4 p-1">
          <Button icon="pi pi-delete-left" class="w-full p-button-danger p-button-outlined font-bold text-xl py-3" @click="numpadBorrar" />
        </div>
        <div class="col-4 p-1">
          <Button label="0" class="w-full p-button-outlined p-button-secondary font-bold text-xl py-3" @click="numpadAgregar(0)" />
        </div>
        <div class="col-4 p-1">
          <Button icon="pi pi-check" class="w-full p-button-success font-bold text-xl py-3" @click="$emit('confirmar', cantidadTemporal)" />
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary w-full" @click="$emit('cancelar')" />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'ZapiModalNumpad',
  props: {
    visible: { type: Boolean, default: false },
    valorInicial: { type: String, default: '1' }
  },
  emits: ['confirmar', 'cancelar'],
  data() {
    return {
      cantidadTemporal: '1',
      numpadNuevoIngreso: true
    }
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.cantidadTemporal = this.valorInicial;
        this.numpadNuevoIngreso = true;
      }
    }
  },
  methods: {
    numpadAgregar(numero) {
      if (this.numpadNuevoIngreso) {
        this.cantidadTemporal = String(numero);
        this.numpadNuevoIngreso = false;
      } else {
        if (this.cantidadTemporal === '0') {
          this.cantidadTemporal = String(numero);
        } else if (this.cantidadTemporal.length < 3) {
          this.cantidadTemporal += String(numero);
        }
      }
    },
    numpadBorrar() {
      this.numpadNuevoIngreso = false;
      if (this.cantidadTemporal.length > 1) {
        this.cantidadTemporal = this.cantidadTemporal.slice(0, -1);
      } else {
        this.cantidadTemporal = '0';
      }
    }
  }
}
</script>